import InstagramFollowTriggerIntegrationInstructionsComponent from '@cohort/components-xps/components/apps/instagram/triggerIntegrations/follow/InstructionsComponent';
import type {TriggerIntegration} from '@cohort/merchants/apps';
import useSocialStepCompletionColumns from '@cohort/merchants/apps/common/triggers/useSocialStepCompletionColumns';
import InstagramFollowTriggerActionCtaComponentPreview from '@cohort/merchants/apps/instagram/triggerIntegrations/follow/ActionCtaComponentPreview';
import InstagramFollowTriggerConfigComponent from '@cohort/merchants/apps/instagram/triggerIntegrations/follow/ConfigComponent';
import InstagramFollowTriggerStepCompletionTitleComponent from '@cohort/merchants/apps/instagram/triggerIntegrations/follow/StepCompletionTitleComponent';
import InstagramFollowTriggerIntegrationComponentPreview from '@cohort/merchants/apps/instagram/triggerIntegrations/follow/TriggerComponentPreview';
import type {InstagramFollowTriggerStruct} from '@cohort/shared/apps/instagram/triggers/follow';
import {InstagramFollowTriggerIntegrationSpec} from '@cohort/shared/apps/instagram/triggers/follow';

export const InstagramFollowTriggerIntegration: TriggerIntegration<InstagramFollowTriggerStruct> = {
  spec: InstagramFollowTriggerIntegrationSpec,
  configComponent: InstagramFollowTriggerConfigComponent,
  stepCompletionTitleComponent: InstagramFollowTriggerStepCompletionTitleComponent,
  stepCompletionContextComponent: undefined,
  useStepCompletionColumns: context =>
    useSocialStepCompletionColumns<InstagramFollowTriggerStruct>({
      ...context,
      userNameKey: 'username',
    }),
  getTitle: t => t('triggerIntegrations.follow.title', {ns: 'app-instagram'}),
  preview: {
    InstructionsComponent: InstagramFollowTriggerIntegrationInstructionsComponent,
    CtaComponent: InstagramFollowTriggerActionCtaComponentPreview,
    TriggerComponent: InstagramFollowTriggerIntegrationComponentPreview,
  },
};
